import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import * as sisMapActions from "store/modules/rds_sisMap";
import * as layoutActions from "store/modules/rds_layout";

import SisModal from "store/sis/sisModal";

import stl from "./AtpModal.module.scss";

class ATPModal extends Component {
	state = {
		locName: "전라남도 무안군 삼향읍 남악리",
		data: [
			{ conDttm: "2020.07", conDate: "29", exArea: "58.85", exPay: 21000, exLayer: 2 },
			{ conDttm: "2020.07", conDate: "29", exArea: "58.85", exPay: 21000, exLayer: 2 },
			{ conDttm: "2020.07", conDate: "29", exArea: "58.85", exPay: 21000, exLayer: 2 },
			{ conDttm: "2020.07", conDate: "29", exArea: "58.85", exPay: 21000, exLayer: 2 },
			{ conDttm: "2020.07", conDate: "29", exArea: "58.85", exPay: 21000, exLayer: 2 },
			{ conDttm: "2020.07", conDate: "29", exArea: "58.85", exPay: 21000, exLayer: 2 },
			{ conDttm: "2020.07", conDate: "29", exArea: "58.85", exPay: 21000, exLayer: 2 },
			{ conDttm: "2020.07", conDate: "29", exArea: "58.85", exPay: 21000, exLayer: 2 },
			{ conDttm: "2020.07", conDate: "29", exArea: "58.85", exPay: 21000, exLayer: 2 },
			{ conDttm: "2020.07", conDate: "29", exArea: "58.85", exPay: 21000, exLayer: 2 },
			{ conDttm: "2020.07", conDate: "29", exArea: "58.85", exPay: 21000, exLayer: 2 },
			{ conDttm: "2020.07", conDate: "29", exArea: "58.85", exPay: 21000, exLayer: 2 },
			{ conDttm: "2020.07", conDate: "29", exArea: "58.85", exPay: 21000, exLayer: 2 },
			{ conDttm: "2020.07", conDate: "29", exArea: "58.85", exPay: 21000, exLayer: 2 },
			{ conDttm: "2020.07", conDate: "29", exArea: "58.85", exPay: 21000, exLayer: 2 },
			{ conDttm: "2020.07", conDate: "29", exArea: "58.85", exPay: 21000, exLayer: 2 },
		],
	};

	componentDidMount() {
		const { LayoutActions } = this.props;

		LayoutActions.setModal({
			id: "realEstateModal",
			target: this.realEstateModal,
		});
	}

	render() {
		const contents = (
			<div className={stl.contentWrapper}>
				<table className={stl.srchTable}>
					<caption>부동산(아파트)</caption>
					<thead>
						<tr>
							<td className={stl.title}>지번주소</td>
							<td className={stl.data}>{this.state.locName}</td>
						</tr>
					</thead>
				</table>
				<div className={stl.searchWrapper}>
					<span>명칭 : </span>
					<span></span>

					<label htmlFor="searchWrapper">전용면적 : </label>
					<select id="searchWrapper">
						<option>선택</option>
						<option>테스트1</option>
						<option>테스트2</option>
						<option>테스트3</option>
					</select>
				</div>
				<table className={stl.rsltTable}>
					<caption>계약정보</caption>
					<thead>
						<tr>
							<th>계약월</th>
							<th>계약일</th>
							<th>전용면적(㎡)</th>
							<th>거래금액(만원)</th>
							<th>층</th>
						</tr>
					</thead>
					<tbody>
						{this.state.data.map((item, idx) => {
							return (
								<tr className={stl.dataList} key={idx}>
									<td>{item.conDttm}</td>
									<td>{item.conDate}</td>
									<td>{item.exArea}</td>
									<td>{item.exPay}</td>
									<td>{item.exLayer}</td>
								</tr>
							);
						})}
					</tbody>
				</table>
			</div>
		);

		return (
			<div>
				<SisModal id={this.props.id} ref={(ref) => (this.realEstateModal = ref)} className={stl.atpModal} draggable title="실거래가 정보" contents={contents} />
			</div>
		);
	}
}

export default connect(
	(state) => ({
		layout: state.layout,
		sis: state.sisMap,
	}),
	(dispatch) => ({
		SisMapActions: bindActionCreators(sisMapActions, dispatch),
		LayoutActions: bindActionCreators(layoutActions, dispatch),
	})
)(ATPModal);
